import { FC, useState } from "react";
import useEvent from "react-use-event-hook";

import { ViewDto } from "@ryde/shared";

import { DialogViewEdit, SaveViewButton, ViewDropdown } from "./parts";
import { ViewContext } from "./view.context";

export const ViewHandlingPanel: FC = () => {
  const [editViewState, setEditViewState] = useState<{
    isOpened: boolean;
    viewDto: ViewDto | undefined;
  }>({ isOpened: false, viewDto: undefined });

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const closeEditView = useEvent(() => {
    setEditViewState({ isOpened: false, viewDto: undefined });
  });

  return (
    <ViewContext.Provider
      value={{
        isDropdownOpen,
        setIsDropdownOpen,
        isEditViewOpen: editViewState.isOpened,
        openEditView: (viewDto?: ViewDto) =>
          setEditViewState({ isOpened: true, viewDto }),
        editView: editViewState.viewDto,
      }}
    >
      <SaveViewButton />
      <ViewDropdown />
      {editViewState.isOpened && (
        <DialogViewEdit view={editViewState.viewDto} onClose={closeEditView} />
      )}
    </ViewContext.Provider>
  );
};
